import { useState } from "react";

const photoLocations = [
  { name: "CVS Pharmacy — Youree Dr", address: "7625 Youree Dr, Shreveport, LA 71105", hours: "Daily 7 AM – 10 PM" },
  { name: "Walgreens — Line Ave", address: "6230 Line Ave, Shreveport, LA 71106", hours: "24 Hours" },
  { name: "CVS Pharmacy — Bossier City", address: "3920 Airline Dr, Bossier City, LA 71111", hours: "Daily 7 AM – 10 PM" },
  { name: "The UPS Store — Shreveport", address: "3306 Line Ave, Shreveport, LA 71104", hours: "Call for hours" },
  { name: "Walgreens — Bossier City", address: "2828 Airline Dr, Bossier City, LA 71111", hours: "24 Hours" },
  { name: "FedEx Office — Shreveport", address: "7550 Youree Dr, Shreveport, LA 71105", hours: "Call for hours" },
];

const dmvLocations = [
  { name: "OMV Shreveport Main Office", address: "8805 Jewella Ave, Shreveport, LA 71108", hours: "Mon–Fri, 8:00 AM – 4:30 PM", note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.", featured: true },
  { name: "OMV Bossier City Branch", address: "4604 Shed Rd, Bossier City, LA 71111", hours: "Mon–Fri, 8:00 AM – 4:30 PM", note: "Bossier City and Barksdale AFB area option.", featured: false },
];

export default function ShreveportHelpfulResourcesSection() {
  const [photoExpanded, setPhotoExpanded] = useState(false);
  const visiblePhotos = photoExpanded ? photoLocations : photoLocations.slice(0, 4);

  return (
    <section id="local-resources" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">Helpful Resources for Shreveport Travelers</h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Getting your passport ready involves more than just the application. Here are local Shreveport and Bossier City resources to help you gather everything you need.
          </p>
        </div>

        <div className="space-y-6">
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-[#1A365D] px-6 py-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0">
                <i className="ri-camera-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Passport Photos</p>
                <p className="text-white font-bold text-base leading-tight mt-0.5">Passport Photo Locations Near Shreveport</p>
              </div>
            </div>
            <div className="px-6 py-6">
              <p className="text-gray-500 text-sm leading-relaxed mb-4">Your passport application requires two identical 2&quot;&times;2&quot; passport photos taken within the last 6 months.</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-4">
                {visiblePhotos.map((loc, i) => (
                  <div key={i} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-3.5">
                    <p className="font-bold text-[#1A365D] text-xs leading-snug mb-1">{loc.name}</p>
                    <p className="text-gray-500 text-xs leading-relaxed">{loc.address}</p>
                    <p className="text-gray-400 text-xs mt-1">{loc.hours}</p>
                  </div>
                ))}
              </div>
              {!photoExpanded && (
                <button onClick={() => setPhotoExpanded(true)} className="text-[#1A365D] hover:text-[#F6C344] font-semibold text-xs flex items-center gap-1.5 mb-4 cursor-pointer transition-colors">
                  <i className="ri-add-circle-line text-sm"></i> Show all {photoLocations.length} photo locations
                </button>
              )}
              <div className="bg-[#F7F8FA] border border-gray-200 rounded-md p-3">
                <p className="text-gray-600 text-xs leading-relaxed"><i className="ri-lightbulb-line text-[#F6C344] mr-1.5"></i><strong>Tip:</strong> Wear a plain white or off-white top, no glasses, neutral expression. Photos must meet strict U.S. State Department specifications.</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-[#1A365D] px-6 py-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0">
                <i className="ri-id-card-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Driver&apos;s License &amp; State ID</p>
                <p className="text-white font-bold text-base leading-tight mt-0.5">Louisiana OMV — DMV Services</p>
              </div>
            </div>
            <div className="px-6 py-6">
              <p className="text-gray-500 text-sm leading-relaxed mb-5">A valid government-issued photo ID is required for your passport application. The Louisiana Office of Motor Vehicles (OMV) handles driver&apos;s licenses and REAL ID in the Shreveport-Bossier area.</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
                {dmvLocations.map((loc, i) => (
                  <div key={i} className={`rounded-lg p-4 border ${loc.featured ? "bg-amber-50 border-[#F6C344]/40" : "bg-[#F7F8FA] border-gray-200"}`}>
                    <p className="font-bold text-[#1A365D] text-xs leading-snug">{loc.name}</p>
                    <p className="text-gray-500 text-xs mt-1">{loc.address}</p>
                    <p className="text-gray-400 text-xs mt-0.5">{loc.hours}</p>
                    <p className="text-[#1A365D] text-xs font-medium mt-1.5">{loc.note}</p>
                  </div>
                ))}
              </div>
              <div className="flex flex-wrap gap-4">
                <a href="https://expresslane.dps.louisiana.gov/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-xs transition-colors"><i className="ri-external-link-line text-sm"></i>Louisiana OMV ExpressLane</a>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-[#1A365D] px-6 py-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0">
                <i className="ri-file-list-3-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Vital Records</p>
                <p className="text-white font-bold text-base leading-tight mt-0.5">Obtaining Certified Documents in Louisiana</p>
              </div>
            </div>
            <div className="px-6 py-6">
              <p className="text-gray-500 text-sm leading-relaxed mb-5">
                Certified copies of vital records are required for passport applications — especially for first-time applicants, name changes, and minors. Here&apos;s where Louisiana residents can obtain them:
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                {[
                  { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from the Louisiana Department of Health Vital Records Registry. Online, mail, or in-person options available for all Louisiana parishes.", url: "https://ldh.la.gov/page/651" },
                  { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Marriage license records are maintained by the parish clerk of court where the license was issued. Contact your parish clerk for certified copies needed for passport name change applications.", url: "https://ldh.la.gov/page/vital-records" },
                  { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Certified divorce records are available through the parish clerk of court where the divorce was granted. Required for name restoration passport corrections.", url: "https://ldh.la.gov/page/vital-records" },
                  { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Certified death certificates through the LA Dept. of Health Vital Records Registry. Required for estate and legal matters.", url: "https://ldh.la.gov/page/652" },
                ].map((item, i) => (
                  <a key={i} href={item.url} target="_blank" rel="noopener noreferrer nofollow" className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-4 flex items-start gap-3 hover:border-[#F6C344]/50 transition-colors">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white flex-shrink-0 mt-0.5">
                      <i className={`${item.icon} text-[#1A365D] text-base`}></i>
                    </div>
                    <div>
                      <p className="font-bold text-[#1A365D] text-xs leading-snug">{item.label}</p>
                      <p className="text-gray-500 text-xs leading-relaxed mt-1">{item.desc}</p>
                    </div>
                  </a>
                ))}
              </div>
              <div className="flex flex-wrap gap-4">
                <a href="https://www.vitalchek.com/" target="_blank" rel="noopener noreferrer nofollow" className="inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-xs transition-colors">
                  <i className="ri-external-link-line text-sm"></i>Order via VitalChek
                </a>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-[#1A365D] px-6 py-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0">
                <i className="ri-flight-takeoff-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Airports</p>
                <p className="text-white font-bold text-base leading-tight mt-0.5">Airports Serving Shreveport Travelers</p>
              </div>
            </div>
            <div className="px-6 py-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div className="bg-amber-50 border border-[#F6C344]/40 rounded-lg p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-[#1A365D] font-black text-xl">SHV</span>
                    <span className="text-xs font-bold text-amber-700 bg-amber-100 px-2 py-0.5 rounded-full">Primary</span>
                  </div>
                  <p className="font-bold text-[#1A365D] text-xs mb-1">Shreveport Regional Airport</p>
                  <p className="text-gray-500 text-xs mb-1">5103 Hollywood Ave, Shreveport, LA 71109</p>
                  <p className="text-gray-400 text-xs mb-3">Domestic connections to Dallas, Houston, Atlanta, and Charlotte. About 6 miles southwest of downtown Shreveport.</p>
                  <a href="https://www.shreveportairport.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-xs transition-colors"><i className="ri-external-link-line text-sm"></i>SHV Airport Website</a>
                </div>
                <div className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-[#1A365D] font-black text-xl">DFW</span>
                    <span className="text-xs font-bold text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full">Texas Hub</span>
                  </div>
                  <p className="font-bold text-[#1A365D] text-xs mb-1">Dallas/Fort Worth International Airport</p>
                  <p className="text-gray-500 text-xs mb-1">About 180 miles west of Shreveport via I-20</p>
                  <p className="text-gray-400 text-xs mb-3">Many Shreveport travelers drive to DFW for direct international flights to Europe, Asia, and Latin America.</p>
                  <a href="https://www.dfwairport.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-xs transition-colors"><i className="ri-external-link-line text-sm"></i>DFW Airport Website</a>
                </div>
              </div>
              <div className="bg-amber-50 border border-amber-200 rounded-md p-3">
                <p className="text-gray-600 text-xs leading-relaxed"><i className="ri-passport-line text-amber-500 mr-1.5"></i><strong>Passport required for all international flights.</strong> If your departure is within two weeks, standard processing won&apos;t make it in time — <a href="https://fastpassportcenter.com/checkout/" className="font-bold text-[#1A365D] underline underline-offset-2 hover:text-[#F6C344] transition-colors">expedited processing through Fast Passport Center</a> is your most reliable option.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}